import script from "./WhatsInYourDesign.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhatsInYourDesign.vue?vue&type=script&setup=true&lang=ts"

import "./WhatsInYourDesign.vue?vue&type=style&index=0&id=09a60d7d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09a60d7d"]])

export default __exports__